import { TransType } from "us.collection/constants";
import { IAPIAction } from "us.common/interfaces";

/**
 * Transaction Types actions
 */

export const transactionTypes: Readonly<IAPIAction> = {
  newTransactionType: {
    save: (data) => ({
      type: TransType.SAVE_TRANSACTION_TYPE,
      payload: {
        data,
        isLoading: true,
      },
    }),
    success: (data) => ({
      type: TransType.SAVE_TRANSACTION_TYPE_SUCCESS,
      payload: {
        data,
        isLoading: false,
      },
    }),
    fail: (error) => ({
      type: TransType.SAVE_TRANSACTION_TYPE_FAIL,
      payload: {
        error,
        isLoading: false,
      },
    }),
  },
  transactionTypes: {
    get: (data) => ({
      type: TransType.GET_TRANS_TYPE_STRAT,
      payload: {
        data,
        isLoading: true,
      },
    }),
    success: (data) => ({
      type: TransType.GET_TRANS_TYPE_SUCCESS,
      payload: {
        data,
        isLoading: false,
      },
    }),
    fail: (error) => ({
      type: TransType.GET_TRANS_TYPE_FAIL,
      payload: {
        error,
        isLoading: false,
      },
    }),
  },
};
